import { FormHelperText } from "@mui/material";
import { Box } from "@mui/system";
import { forwardRef } from "react";
import { FormInputProps } from "./FormInput.types";
import { FormLabel } from "./FormLabel";
import { CustomInput } from "./CustomInput";

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>((props, ref) => {
  const { width = "15.625rem", fullWidth = true, size = "small", required, label, helperText, ...others } = props;
  const error = !!helperText;

  return (
    <Box sx={{ width: fullWidth ? "100%" : width }}>
      {label && <FormLabel error={error} label={label} required={required} />}
      <CustomInput ref={ref} fullWidth={true} size={size} error={error} {...others} />
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </Box>
  );
});

export default FormInput;
